/**
 * Spinner  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export enum SPINNER_SIZE {
	XSMALL = "xsmall", // 16
	SMALL = "small", // 20
	MEDIUM = "medium", // 24
	LARGE = "large", // 32
	CUSTOM = "custom"
}

export interface ISpinnerProps {
	size?: SPINNER_SIZE;
	className?: string;
}

export const Spinner: React.FC<ISpinnerProps> = ({ size, className }) => {
	const baseClass = BEM("edt-spinner", null, { size });

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<div className={baseClass.element("main").toClassName()}>
				<span className={baseClass.element("inner").toClassName()} />
			</div>
		</div>
	);
};

Spinner.defaultProps = {
	size: SPINNER_SIZE.MEDIUM
};
